import { FaGlobe } from "react-icons/fa";
import CertificateCard from "../../../../../ReusableComponent/CertificateCard"

const certifications = [
  // ================= FRONTEND =================
  {
    title: "JavaScript",
    level: "Beginner to Expert",
    duration: "45 min",
    questions: "50",
    link: "/certification/JavaScript",
    category: "frontend",
  },
  {
    title: "React",
    level: "Beginner to Advanced",
    duration: "60 min",
    questions: "40",
    link: "/certification/React",
    category: "frontend",
  },
  {
    title: "Vue.js",
    level: "Beginner to Advanced",
    duration: "50 min",
    questions: "45",
    link: "/certification/Vue",
    category: "frontend",
    disabled: true,
  },
  {
    title: "Angular",
    level: "Beginner to Advanced",
    duration: "55 min",
    questions: "42",
    link: "/certification/Angular",
    category: "frontend",
  },
  {
    title: "CSS",
    level: "Beginner to Expert",
    duration: "40 min",
    questions: "35",
    link: "/certification/CSS",
    category: "frontend",
  },
  {
    title: "TypeScript",
    level: "Intermediate to Expert",
    duration: "50 min",
    questions: "38",
    link: "/certification/TypeScript",
    category: "frontend",
  },
  {
    title: "HTML",
    level: "Intermediate to Expert",
    duration: "50 min",
    questions: "38",
    link: "/certification/TypeScript",
    category: "frontend",
  },
  {
    title: "Bootstrap",
    level: "Intermediate to Expert",
    duration: "50 min",
    questions: "38",
    link: "/certification/TypeScript",
    category: "frontend",
  },

  // ================= BACKEND =================
  {
    title: "Node.js",
    level: "Beginner to Expert",
    duration: "60 min",
    questions: "45",
    link: "/certification/Node",
    category: "backend",
  },
   {
    title: "Express.js",
    level: "Beginner to Expert",
    duration: "60 min",
    questions: "45",
    link: "/certification/Express",
    category: "backend",
  },
  {
    title: "Python",
    level: "Beginner to Expert",
    duration: "55 min",
    questions: "50",
    link: "/certification/Python",
    category: "backend",
  },
  {
    title: "Java",
    level: "Beginner to Expert",
    duration: "65 min",
    questions: "48",
    link: "/certification/Java",
    category: "backend",
  },
  {
    title: "C#",
    level: "Beginner to Advanced",
    duration: "50 min",
    questions: "40",
    link: "/certification/CSharp",
    category: "backend",
    disabled: true,
  },
  {
    title: "Go",
    level: "Intermediate to Expert",
    duration: "45 min",
    questions: "35",
    link: "/certification/Go",
    category: "backend",
    disabled: true,
  },
  {
    title: "Ruby",
    level: "Beginner to Advanced",
    duration: "50 min",
    questions: "38",
    link: "/certification/Ruby",
    category: "backend",
    disabled: true,
  },

  // ================= DATABASE & DEVOPS =================
  {
    title: "MySQL",
    level: "Beginner to Expert",
    duration: "50 min",
    questions: "40",
    link: "/certification/MySQL",
    category: "devops",
  },
  {
    title: "MongoDB",
    level: "Beginner to Advanced",
    duration: "45 min",
    questions: "35",
    link: "/certification/MongoDB",
    category: "devops",
  },
  {
    title: "Docker",
    level: "Intermediate to Expert",
    duration: "40 min",
    questions: "30",
    link: "/certification/Docker",
    category: "devops",
    disabled: true,
  },
  {
    title: "Kubernetes",
    level: "Advanced to Expert",
    duration: "60 min",
    questions: "25",
    link: "/certification/Kubernetes",
    category: "devops",
    disabled: true,
  },
  {
    title: "AWS",
    level: "Beginner to Expert",
    duration: "70 min",
    questions: "55",
    link: "/certification/AWS",
    category: "devops",
    disabled: true,
  },
  {
    title: "Git",
    level: "Beginner to Advanced",
    duration: "30 min",
    questions: "25",
    link: "/certification/Git",
    category: "devops",
  },

  // ================= MOBILE =================
  {
    title: "React Native",
    level: "Beginner to Advanced",
    duration: "55 min",
    questions: "42",
    link: "/certification/ReactNative",
    category: "mobile",
    disabled: true,
  },
  {
    title: "Flutter",
    level: "Beginner to Advanced",
    duration: "60 min",
    questions: "45",
    link: "/certification/Flutter",
    category: "mobile",
    disabled: true,
  },
  {
    title: "Swift",
    level: "Intermediate to Expert",
    duration: "50 min",
    questions: "38",
    link: "/certification/Swift",
    category: "mobile",
    disabled: true,
  },
  {
    title: "Kotlin",
    level: "Intermediate to Expert",
    duration: "55 min",
    questions: "40",
    link: "/certification/Kotlin",
    category: "mobile",
    disabled: true,
  },
  // {
  //   title: "Xamarin",
  //   level: "Beginner to Advanced",
  //   duration: "45 min",
  //   questions: "35",
  //   link: "/certification/Xamarin",
  //   category: "mobile",
  //   disabled: true,
  // },
];

const TechSection = ({ category }) => {
  return (
    <section className="my-5">
      {/* Heading */}

      <div className="d-flex align-items-center mb-4">
        <FaGlobe className="text-primary me-2" size={22} />
        <h5 className="fw-bold text-light mb-0 text-capitalize">{category} Development</h5>
      </div>

      {/* Cards */}
      <div className="row">
        {certifications.filter((item) => item.category === category).map((cert, idx) => (
          <CertificateCard key={idx} {...cert} />
        ))}
      </div>
    </section>
  );
};

export default TechSection;